/*
 * Attachments Audit History Component
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2023 Gallagher Bassett Services, Inc.
 */

import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { take } from 'rxjs/operators';
import {
  AttachmentService,
} from 'app/shared/services';
import { AttachmentsAuditHistory, AttachmentsAuditHistoryRecord } from "app/shared/models";

@Component ( {
    selector: 'reporter-attachments-audit-history',
    templateUrl: './attachments-audit-history.component.html',
    styleUrls: ['./attachments-audit-history.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
} )
export class AttachmentsAuditHistoryComponent implements OnInit {
  @Input () incidentId: string;
  @Output () close = new EventEmitter<any> ();

  auditHistory: AttachmentsAuditHistoryRecord[];
  pageNumber = 1;
  readonly pageSize = 50;
  totalPages = 0;
  totalRecords = 0;
  @ViewChild ( 'resultsBody', { static: false } ) resultsBody: ElementRef;
  noScrollbar: boolean;

  constructor( private service: AttachmentService ) {
  }

  async ngOnInit() {
    this.auditHistory = [];
    this.getHistoryPage ();
  }

  getHistoryPage() {
    this.service.getAuditHistory ( this.incidentId, this.pageNumber, this.pageSize ).pipe ( take ( 1 ) )
      .subscribe ( result => {
        this.auditHistory.push ( ...result.records );
        this.totalPages = result.totalPages;
        this.totalRecords = result.totalRecords;
        setTimeout ( () => {
          this.noScrollbar = this.resultsBody?.nativeElement.scrollHeight <= this.resultsBody?.nativeElement.clientHeight;
        }, 0 );
      } );
  }

  loadNextPage() {
    if ( this.pageNumber < this.totalPages ) {
      this.pageNumber++;
      this.getHistoryPage ();
    }
  }
}
